module.exports = __webpack_public_path__ + "56c5251a5de21d8469a7fa87d22ca25f.MP3";